<div class="jumbotron centered-text">
  <b>{{data.selectEntities.count}}</b> záborů bude {{ getActionLabel() }}.
  <ng-container *ngIf="data.details.action === FinalSolutionStateEnum.REJECTED && data.details.note">
    <br/><span>Důvod: <em>{{data.details.note}}</em></span>
  </ng-container>
</div>
